import React from "react";
import Grid from "@material-ui/core/Grid";
import "./fieldset.css";

const Fieldset = ({ titulo = "Busca rápida", inputs = [] }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <fieldset>
          <legend>{titulo}</legend>
          <Grid container spacing={2} style={{ marginTop: "0em" }}>
            {inputs.map((input, index) => {
              return (
                <Grid
                  item
                  xs={6}
                  md={4}
                  lg={input.component.props.lg}
                  key={`grid-filter-${index}`}
                >
                  {input.component}
                </Grid>
              );
            })}
          </Grid>
        </fieldset>
      </Grid>
    </Grid>
  );
};

export default Fieldset;
